export default "/images/8664cc3eb7cb2c165d48d2939bfe3a46.avif";